// DateFormats.js
const DateFormats = {
  // ISO standard formats (useful for APIs, databases)
  ISO_DATE: 'YYYY-MM-DD', // 2025-05-20
  ISO_YEAR_MONTH: 'YYYY-MM', // 2025-05
  ISO_DATETIME: 'YYYY-MM-DD HH:mm:ss', // 2025-05-20 14:30:00
  ISO_DATETIME_TZ: 'YYYY-MM-DDTHH:mm:ssZ', // 2025-05-20T14:30:00+00:00
  ISO_TIME: 'HH:mm:ss',
  ISO_DATE_SLASHED: 'YYYY/MM/DD', // 2025/05/20

  // User-friendly display formats
  DISPLAY_DATE: 'DD/MM/YYYY', // 20/05/2025
  DISPLAY_DATETIME: 'DD/MM/YYYY HH:mm', // 20/05/2025 14:30
  DISPLAY_DATETIME_AMPM: 'DD/MM/YYYY hh:mm A', // 20/05/2025 06:30 PM
  DISPLAY_DATETIME_AMPM_LOWER: 'DD/MM/YYYY hh:mm a', // 20/05/2025 06:30 PM
  DISPLAY_DATETIME_SECONDS: 'DD/MM/YYYY hh:mm:ss',
  DISPLAY_TIME: 'HH:mm', // 14:30
  DISPLAY_TIME_AMPM: 'hh:mm A', // 06:30 PM
  DISPLAY_TIME_AMPM_LOWER: 'hh:mm a', // 06:30 pm

  // HTML input formats
  HTML_DATE: 'YYYY-MM-DD', // for <input type="date">
  HTML_TIME: 'HH:mm', // for <input type="time">

  // Formats for filenames, logs, or identifiers
  FILE_TIMESTAMP: 'YYYYMMDD_HHmmss', // 20250520_143000

  // Readable month and year
  MONTH_YEAR: 'MMMM YYYY', // May 2025
  MONTH_YEAR_WITH_PREPOSITION: 'MMM [de] YYYY', // "Abr de 2026"
  FULL_MONTH_YEAR: 'MMMM YYYY', // Abril 2026

  // Weekday + date
  WEEKDAY_DATE: 'dddd DD/MM/YYYY', // Tuesday 20/05/2025 (localized)
  WEEKDAY_DATE_LONG: 'dddd DD [de] MMMM YYYY', // Monday 12 de October 2026

  // Compact format
  SHORT_DATE: 'DD/MM', // 20/05

  YEAR_MONTH: 'YYYYMM', // 202505
  LONG_MONTH: 'MMMM', // May (localized)
  DAY_MONTH: 'DD MMMM', // 20 May (localized)
};

export default DateFormats;
